import styled from "styled-components";
import { SubTitle, Text } from "../../common/texts";

export const Wrapper = styled.section`
  padding: 60px var(--p-container);

  @media (max-width: 768px) {
    padding: 40px var(--p-container);
  }
`;

export const Card = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.22);

  @media (max-width: 768px) {
    flex-direction: column;
    border-radius: 18px;
  }
`;

export const LeftContent = styled.div`
  flex: 1 1 45%;
  background: linear-gradient(135deg, #1f1f1f 0%, #000 100%);
  color: #fff;
  padding: 55px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${SubTitle} {
    position: relative;
    margin-bottom: 26px;
    line-height: 1.35;

    &::after {
      content: "";
      display: block;
      width: 70px;
      height: 4px;
      margin-top: 16px;
      background: var(--primary);
      border-radius: 4px;
    }
  }

  ${Text} {
    line-height: 1.9;
  }

  @media (max-width: 768px) {
    padding: 38px 28px;
    text-align: center;

    ${SubTitle}::after {
      margin-left: auto;
      margin-right: auto;
    }
    ${Text} {
      text-align: center;
    }
  }
`;

export const RightContent = styled.div`
  flex: 1 1 55%;
  position: relative;
  min-height: 460px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    transition: transform 0.6s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    min-height: unset;
    aspect-ratio: 4 / 3;
  }
`;
